var map = {
	"./D.svg": "nyti"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xm7Z";


//////////////////
// WEBPACK FOOTER
// ./src/icons nonrecursive \.svg$
// module id = Xm7Z
// module chunks = 2